import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { BellIcon, CheckIcon } from 'lucide-react';
export function DealAlerts() {
  const [email, setEmail] = useState('');
  const [selectedTypes, setSelectedTypes] = useState<string[]>([]);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const dealTypes = ['Cash-Flowing Properties', 'Equity Plays / Fixer-Uppers', 'Vacant Land', 'Commercial Opportunities', 'Pre-Construction Deals'];
  const handleTypeToggle = (type: string) => {
    setSelectedTypes(prev => prev.includes(type) ? prev.filter(t => t !== type) : [...prev, type]);
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email && selectedTypes.length > 0) {
      console.log('Alert subscription:', {
        email,
        selectedTypes
      });
      setIsSubmitted(true);
      setTimeout(() => {
        setIsSubmitted(false);
        setEmail('');
        setSelectedTypes([]);
      }, 3000);
    }
  };
  return <section className="py-24 bg-navy" data-id="element-105">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-106">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-107">
          <BellIcon className="text-gold mx-auto mb-4" size={48} data-id="element-108" />
          <h2 className="text-4xl sm:text-5xl font-serif font-bold text-white mb-6" data-id="element-109">
            Join the Alert List
          </h2>
          <p className="text-xl text-white/80 max-w-2xl mx-auto" data-id="element-110">
            Tell us what you're looking for. When a deal that matches hits our
            radar, we'll reach out — only then.
          </p>
          <p className="text-white/60 mt-4" data-id="element-111">
            Email only. No spam. No sales calls.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-charcoal rounded-lg p-8 sm:p-10 border border-white/10" data-id="element-112">
          {isSubmitted ? <div className="text-center py-8" data-id="element-113">
              <CheckIcon className="text-gold mx-auto mb-4" size={64} data-id="element-114" />
              <h3 className="text-2xl font-serif font-bold text-white mb-2" data-id="element-115">
                You're on the list!
              </h3>
              <p className="text-white/80" data-id="element-116">
                We'll notify you when deals matching your criteria become
                available.
              </p>
            </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-117">
              <div data-id="element-118">
                <label className="block text-white font-semibold mb-3" data-id="element-119">
                  What type of deals interest you? (Select all that apply)
                </label>
                <div className="space-y-3" data-id="element-120">
                  {dealTypes.map(type => <label key={type} className="flex items-center text-white/80 hover:text-white cursor-pointer group" data-id="element-121">
                      <div className="relative" data-id="element-122">
                        <input type="checkbox" checked={selectedTypes.includes(type)} onChange={() => handleTypeToggle(type)} className="sr-only" data-id="element-123" />
                        <div className={`w-5 h-5 border-2 rounded transition-all ${selectedTypes.includes(type) ? 'bg-gold border-gold' : 'border-white/30 group-hover:border-gold/50'}`} data-id="element-124">
                          {selectedTypes.includes(type) && <CheckIcon className="text-navy" size={16} strokeWidth={3} data-id="element-125" />}
                        </div>
                      </div>
                      <span className="ml-3" data-id="element-126">{type}</span>
                    </label>)}
                </div>
              </div>

              <div data-id="element-127">
                <label className="block text-white font-semibold mb-3" data-id="element-128">
                  Your Email Address
                </label>
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="investor@example.com" required className="w-full bg-navy text-white border border-white/20 rounded-lg px-4 py-3 focus:outline-none focus:border-gold transition-colors" data-id="element-129" />
              </div>

              <button type="submit" disabled={selectedTypes.length === 0 || !email} className="w-full bg-gold hover:bg-gold-light text-navy px-8 py-4 rounded-lg font-bold text-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-130">
                Subscribe to Deal Alerts
              </button>
            </form>}
        </motion.div>
      </div>
    </section>;
}